import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Popover from '../../utils/Popover';
import Icon from '../../general/Icon';
import Text from '../../typography/Text';

import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Label');

function Label({
    children,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    isRequired,
    hint,
    isDisabled,
}) {
    const classes = useClasses(useStyles, classesProp);
    // Overrides
    const override = getOverrides(overridesProp, Text.overrides);

    // Classes
    const rootClassName = classnames(classes.root, classNameProp);

    const rootProps = {
        className: rootClassName,
    };

    return (
        <div {...rootProps} {...override.root}>
            <Text type="body" light={isDisabled} className={classes.Text} {...override.Text}>
                {children}
                {isRequired && '*'}
            </Text>
            {hint && (
                <Popover
                    className={classes.Popover}
                    placement="top"
                    trigger={['hover']}
                    content={hint}
                    {...override.Popover}
                >
                    <span className={classes.info}>
                        <Icon className={classes.icon} name="info" />
                    </span>
                </Popover>
            )}
        </div>
    );
}

Label.overrides = ['root', 'Popover', 'Text'];

Label.propTypes = {
    /** Content of the label */
    children: PropTypes.node,
    /** Custom className for styling purposes */
    className: PropTypes.string,
    /** Object with custom style overrides for inner elements */
    overrides: PropTypes.object,
    /** When true, displays an asterisk next to the label indicating the field is required */
    isRequired: PropTypes.bool,
    /** Tooltip text displayed in an info icon next to the label */
    hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /** When true, displays the label in a disabled state with lighter text color */
    isDisabled: PropTypes.bool,
};

export default React.memo(Label);
